import { useSidebarsWidthStore } from "@core-ui/ContextServices/Sidebars/SidebarsWidthStore";
import { useCallback, useLayoutEffect, useRef } from "react";

// Drag updates stay inside the fixed navigation; the article follows the committed root width.
export const useLeftNavigationWidthPreview = () => {
	const width = useSidebarsWidthStore((state) => state.leftWidth);
	const navigationRef = useRef<HTMLDivElement>(null);
	const bottomRef = useRef<HTMLDivElement>(null);

	const previewWidth = useCallback((nextWidth: number) => {
		for (const element of [navigationRef.current, bottomRef.current]) {
			element?.style.setProperty("--sidebar-width", `${nextWidth}px`);
		}
	}, []);

	useLayoutEffect(() => {
		previewWidth(width);
	}, [width, previewWidth]);

	return { navigationRef, bottomRef, previewWidth };
};
